import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initErrorTracking } from './utils/errorTracking';

// Initialize error tracking
initErrorTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
